import script from "./WCOrderTypeCartPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCOrderTypeCartPicker.vue?vue&type=script&setup=true&lang=ts"

import "./WCOrderTypeCartPicker.vue?vue&type=style&index=0&id=1d01b098&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d01b098"]])

export default __exports__